// extracted by mini-css-extract-plugin
export default {"Separador1":"Skills_Separador1__6CJAQ","SeparatorEscImg":"Skills_SeparatorEscImg__yq-mt"};